import { render, staticRenderFns } from "./ElectricalPDSensorsOverview.vue?vue&type=template&id=723f52b5&scoped=true&lang=pug"
import script from "./ElectricalPDSensorsOverview.vue?vue&type=script&lang=js"
export * from "./ElectricalPDSensorsOverview.vue?vue&type=script&lang=js"
import style0 from "./ElectricalPDSensorsOverview.vue?vue&type=style&index=0&id=723f52b5&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723f52b5",
  null
  
)

export default component.exports